// Libraries
import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, Button } from 'antd'
import { Field } from 'formik'
// Styles
import { Selectantd } from '../../../EditProfile/Modals/styles'
import { ErrorMessage, Label, OptionContainer, OptionLabel, OptionTrashIcon } from '../styles'
import { Title } from '../../../EditProfile/Inputs/styles.js'
// Constants
import { TextGrayColor } from '../../../../constants/constants'

const Select = ({
  name,
  label,
  options,
  showDeleteOption = false,
  onDeleteOption,
  resetForm,
  title,
  containerStyle,
  selectStyle,
  ...props
}) => {
  const onChangeUpdated = (form) => (props.onChange ? props.onChange : (value) => form.setFieldValue(name, value))

  return (
    <div style={containerStyle}>
      {title && <Title>{title}:</Title>}
      {label && <Label htmlFor={name}>{label}</Label>}
      <Field name={name} {...props}>
        {({ field, form }) => (
          <div>
            <Selectantd
              bordered={false}
              {...props}
              value={field.value}
              onChange={onChangeUpdated(form)}
              onBlur={() => form.setFieldTouched(name, true)}
              style={{ width: props.width || 220, marginBottom: '0.25rem', ...selectStyle }}>
              {options.map((option, index) => (
                <Selectantd.Option
                  key={`${option.value}_${index}`}
                  value={option.value}
                  style={{ color: TextGrayColor, margin: '5px', padding: '5px', fontSize: '1rem' }}>
                  <Tooltip placement='right' title={option.tooltipText || (showDeleteOption && 'Delete register')}>
                    <OptionContainer showDeleteOption>
                      <OptionLabel>{option.label}</OptionLabel>
                      {showDeleteOption && (
                        <Button
                          type='text'
                          icon={<OptionTrashIcon />}
                          onClick={(e) => onDeleteOption(e, option.value, resetForm)}
                        />
                      )}
                    </OptionContainer>
                  </Tooltip>
                </Selectantd.Option>
              ))}
            </Selectantd>
            <ErrorMessage name={name} component='div' className='error' />
          </div>
        )}
      </Field>
    </div>
  )
}

Select.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  title: PropTypes.string,
  onChange: PropTypes.func,
  showDeleteOption: PropTypes.bool,
  onDeleteOption: PropTypes.func,
  resetForm: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      tooltipText: PropTypes.string
    })
  ).isRequired,
  width: PropTypes.string,
  containerStyle: PropTypes.object,
  selectStyle: PropTypes.object
}

export default Select
